import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useCloneTopic({ classID, chapterID }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function cloneTopic(data) {
    return privateFetch
      .post(`/v1/admin/class/${classID}/chapter/${chapterID}/topic/clone`, data)
      .then((res) => res.data);
  }

  return useMutation(cloneTopic, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('chapters');
    },
  });
}

export default useCloneTopic;
